<template>
    <date-picker 
        v-model="amount"
        :value-type="valueType"
        :append-to-body="true"
        :minute-step="minuteStep"
        :lang="ja"
        :width="width"
        :placeholder="placeholder"
        :input-class="'clearable no-enter-as-tab ' + inputClass"
        :input-attr="{id: elementId, maxlength: maxLength}"
        :input-name="inputName"
        :type="type"
        :not-before="notBeforeNew"
        :not-after="notAfterNew"
        :disabled="disabled"
        :clearable="false"
        :format="format"
        ref="datepicker"
        id="datepicker"
        @input="onInputHandler"
        @focus="onFocus"
        @blur="onBlur"
        @input-error="inputError">
        <template v-if="type == 'date'" slot="header">
            <div class="mx-shortcuts-wrapper bg-primary" ref="appendPopup">
                <div class="row m-0 text-white">
                    <div class="text-left extend-header">
                        <!-- ? -->
                        <a class="shortcuts" @click="getHelp">{{$t('calendar.buttons.help')}}</a>
                    </div>
                    <div class="col text-center extend-header">
                        <!-- 当日選択 -->
                        <a class="shortcuts" @click="getToday">{{$t('calendar.buttons.today')}}</a>
                    </div>
                    <div class="text-right extend-header">
                        <!-- x -->
                        <a class="shortcuts" @click="close">{{$t('calendar.buttons.close')}}</a>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="type == 'time'" slot="footer">
            <div class="mx-shortcuts-wrapper" ref="appendPopup">
                <div class="row m-0 row-timepicker-style">
                    <div class="col-sm text-right extend-header">
                        <!-- x -->
                        <a class="shortcuts-time" @click="close">{{$t('calendar.buttons.close')}}</a>
                    </div>
                </div>
            </div>
        </template>
    </date-picker>
</template>
<script>
import $ from 'jquery';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import common from 'assets/js/common';

export default {
    components: { 
        DatePicker
    },
    props: {
        /**
         * v-model value.
         */
        value: {
            type: [String, Date, Number],
            default: '',
            required: false
        },
        minuteStep: {
            type: Number,
            default: 0
        },
        type: {
            type:String,
            default: 'date'
        },
        elementId: {
            type: String,
            default: ""
        },
        disabled: {
            type: Boolean,
            default: false
        },
        inputName: {
            type: String
        },
        format:{
            type: String,
            default: "YYYY/MM/DD"
        },
        placeholder:{
            type: String,
            default :''
        },
        inputClass:{
            type: String,
            default: ''
        },
        width:{
            type: String,
            default: '100%'
        },
        notBefore:{
            type: String/Date,
            default: ''
        },
        notAfter:{
            type: String/Date,
            default: ''
        },
        valueType: {
            type: String,
            default: 'date'
        }
    },
    computed: {
        /**
         * Number type of value props.
         * @return {Number}
         */
        valueNumber() {
            var _this = this;
            _this.notAfterNew = _this.notAfter;
            _this.notBeforeNew = _this.notBefore;
            if (_this.type == 'time') {
                _this.amount = moment(_this.value, _this.format);
                return _this.amount;
            } else if(_this.type == 'date') {
                _this.amount = _this.value;
                return _this.amount;
            } else if(_this.type == 'month'){
                if(_this.notAfter != undefined){
                    if(_this.notAfter == "Invalid date"){
                        _this.notAfterNew = "";
                    }else{
                        _this.notAfterNew= _this.notAfter.replace("/", "-");
                    }
                }
                if(_this.notBefore != undefined){
                    if(_this.notBefore == "Invalid date"){
                        _this.notBeforeNew = "";
                    }else{
                        _this.notBeforeNew= _this.notBefore.replace("/", "-");
                    }
                }
                var m = moment(_this.value, _this.format);
                if(m.isValid()) {
                    _this.amount = _this.value;
                }
                this.$emit('input', _this.amount);
                this.$emit('on-change', _this.amount);
                return _this.amount;
            }
        }
    },
    watch: {
        /**
         * Watch for value change from other input with same v-model.
         * @param {Number} newValue
         */
        valueNumber (newValue) {
            var _this = this;
            _this.amount = newValue;
            return this.amount;
        },
    },
    data() {
        return {
            amount: '',
            ja: this.$i18n.t('calendar.ja'),
            maxLength: 0,
            notAfterNew: this.notAfter,
            notBeforeNew: this.notBefore

        }
    },
    mounted() {
        var _this = this;
        if (_this.type == 'time') {
            _this.maxLength = 5;
            if(_this.format == 'HH:mm:ss'){
                _this.maxLength = 8;
            }
            
        } else if(_this.type == 'date') {
            _this.maxLength = 10;

        } else if(_this.type == 'month'){
            _this.maxLength = 7;
        }
        if(_this.elementId) {
            var el = document.getElementById(_this.elementId);
            el.addEventListener("keydown", function (e) {
                if (e.which == 13  || e.keyCode == 13) {
                    e.preventDefault();
                    common.focusNext(undefined, el);
                }
            });
        }
        // Set input type='tel' to disabled IME on IE11
        _this.$refs.datepicker.$refs.input.type = 'tel';
    },
    methods: {
        /**
         * Function onBlurWindow
         */
        onBlurWindow: function() {
            try {
                this.$refs.datepicker.closePopup();
            } catch (error) {
                return;
            }
        },
  
        /**
         * Handle input error.
         */
        inputError: function() {
            event.target.value = null;
            let datePicker = this.$children.find(function(item) {
                return item.$options._componentTag === 'date-picker'
            });
            event.target.value = null;
            this.$set(datePicker, 'userInput', null);
            this.$emit('input', null);
        },
        /**
         * Handle input event.
         */
        onInputHandler () {
            if(this.amount == null) {
                this.$emit('input', null);
                this.$emit('on-change', null);
            } else {
                var value = moment(this.amount).format(this.format);
                var dateInput = '';
                if(event.target.value != null){
                    dateInput = event.target.value.toString();
                }
                if((value.substr(0,1) == '-') || (dateInput.substr(0,1) == '-')){
                    this.$emit('input', null);
                    this.$emit('on-change', null);
                } else{
                    this.$emit('input', value);
                    this.$emit('on-change', value);
                }
            }
        },
        /*
        * get today
        */
        getToday: function(){
            this.amount = new Date();
            // Check not before
            if(this.$refs.datepicker.$attrs['not-before'] != '' && this.$refs.datepicker.$attrs['not-before'] != null) {
                let dateAmount = moment(this.amount).format(this.format);
                var dateNotBefore = moment(new Date(this.$refs.datepicker.$attrs['not-before'])).format(this.format);
                if(dateAmount < dateNotBefore){
                    this.amount = null;
                }
            }
            // Check not after
            if(this.$refs.datepicker.$attrs['not-after'] != '' && this.$refs.datepicker.$attrs['not-after'] != null){
                let dateAmount = moment(this.amount).format(this.format);
                var dateNotAfter = moment(new Date(this.$refs.datepicker.$attrs['not-after'])).format(this.format);
                if(dateAmount > dateNotAfter){
                    this.amount = null;
                }
            }
            // Call handle input event function 
            this.onInputHandler();

            //Close popup calander
            this.$refs.datepicker.closePopup();
        },
        /* 
        * Show help
        */
        getHelp: function(){
            var msg = '';
            msg = this.$i18n.t('calendar.labels.msg1') + "\n"+ this.$i18n.t('calendar.labels.msg2') + "\n" + this.$i18n.t('calendar.labels.msg3')+ "\n" + this.$i18n.t('calendar.labels.msg4');
            alert(msg);
            this.$refs.datepicker.closePopup();
        },
        /* 
        * close Popup when click x button on popup
        */
        close() {
            this.$refs.datepicker.closePopup();
        },
        /**
         * Function focusMyself
         */
        focusMyself: function(){
            var _this = this;
            setTimeout(function(){
                _this.$el.children[0].children[0].focus();
            },10)
        },
        /* 
        * onFocus
        */
        onFocus() {
            $(".mx-datepicker-popup").each(function(){
				if($(this).css("display")!="none"){
					$(this).css("display", "none");
				}
			});
            this.$refs.datepicker.closePopup();
            //this.focusMyself();
        },
        /* 
        * onBlur
        */
        onBlur(){
            let datePicker = this.$children.find(function(item) {
                return item.$options._componentTag === 'date-picker'
            });
            var val = this.amount;
            var typeOf = typeof(val);
            if(typeOf == 'object'){
                val = moment(this.amount).format(this.format);
                if(val == 'Invalid date'){
                    val = null;
                }
            }
            this.$set(datePicker, 'userInput', val);
        }
    },
    created() {
        window.addEventListener("blur", this.onBlurWindow);
    },
    beforeDestroy() {
        window.removeEventListener("blur", this.onBlurWindow);
    },
}
</script>
<style>
    .row-timepicker-style {
        position: absolute;
        right: 0;
        top: 5px; 
    }
    .clearable::-ms-clear {
        display: none;
    }
    .shortcuts {
        background: none;
        outline: none;
        border: 0;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        cursor: pointer;
    }
    .shortcuts:hover {
        color: #ffffff !important;
    }
    .shortcuts-time:hover {
        background: none;
        outline: none;
        border: 0;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        cursor: pointer;
    }

    .bg-color-red {
        border-color: red !important;
    }
    .mx-clear-icon::before {
        background-color: #fff;
        width: 20px;
        height: 17px;
        margin-top: -5px;
    }
    .mx-calendar-panel-date .mx-current-month {
        float: right;
        margin-right: 25px;
    }

    .mx-calendar-panel-date .mx-current-year {
        float: left;
        margin-left: 25px;
    }
    
    .mx-calendar-panel-date .mx-current-year::after {
        content: '年';
    }
    .disabled-div{
        background-color: #e9ecef;
    }
    .mx-datepicker-popup {
        z-index: 99999 !important;
    }
</style>

